import { Link } from "gatsby";
import React from "react";
import $ from "jquery";
import { ContextProviderComponent } from "../contextProviderComponent";

import "./modalEmbeededComponent.scss";

import logo from "../../images/logo/logo.svg";
import closeButton from "../../images/icons/close.svg";

import HubSpotComponent from "../hubSpotComponent/hubSpotComponent";

import { TweenMax, Power1 } from "gsap/all";

class ModalEmbeededComponent extends React.Component {
  constructor(props) {
    super(props);

    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.modalEmbeeded = React.createRef();
  }

  showModal() {
    document.querySelector("html").classList.add("stop-scrolling");

    $("#modalEmbeeded").fadeIn();
  }

  closeModal() {
    document.querySelector("html").classList.remove("stop-scrolling");

    $("#modalEmbeeded").fadeOut();
  }

  componentDidUpdate() {
    this.context.state.showForm == "none"
      ? this.closeModal()
      : this.showModal();
  }

  componentDidMount() {
    this.closeModal();
  }

  componentWillUnmount() {
    this.closeModal();
  }

  render() {
    return (
      <div
        className="modalEmbeeded"
        id="modalEmbeeded"
        style={{ display: `${this.props.show}` }}
      >
        <div className="modalEmbeeded-header">
          <div>
            <Link to="/" target="_blank">
              <img alt="smartwealth logo" className="" src={logo}></img>
            </Link>
          </div>
          <div
            className="close-btn"
            onClick={() => this.context.callBackForHubSpotModalShow("none")}
          >
            <img alt="cross close" src={closeButton}></img>
          </div>
        </div>

        <div className="modalEmbeeded-body">
          <HubSpotComponent />
        </div>
      </div>
    );
  }
}

ModalEmbeededComponent.contextType = ContextProviderComponent;
export default ModalEmbeededComponent;
